import { render, staticRenderFns } from "./changedPassword.vue?vue&type=template&id=95ac9a18&scoped=true"
import script from "./changedPassword.vue?vue&type=script&lang=js"
export * from "./changedPassword.vue?vue&type=script&lang=js"
import style0 from "./changedPassword.vue?vue&type=style&index=0&id=95ac9a18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ac9a18",
  null
  
)

export default component.exports